import { rest } from 'msw';

import { getConfig } from 'shared/config';
import { emailsAccountSummaryMock, emailsOCustomerMock, emailsPrivateMock } from '.';

const odinAPI = getConfig().odin?.host;

export const handlers = [
  rest.get(`${odinAPI}/yousee/selfcare/accounts/accountsummary`, (req, res, ctx) =>
    res(ctx.json(emailsAccountSummaryMock)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/emails`, (req, res, ctx) =>
    req.url.search === '?customerType=Private'
      ? res(ctx.json(emailsPrivateMock))
      : res(ctx.json(emailsOCustomerMock)),
  ),
  rest.post(`${odinAPI}/yousee/selfcare/emails/mailbox`, (req, res, ctx) => {
    const body = req.body as any;
    const emailsMock = body.customerType === 'Private' ? emailsPrivateMock : emailsOCustomerMock;
    return res(
      ctx.json({
        mailboxOverview: { ...emailsMock, mailboxesInQueue: [`${body.address}@${body.domain}`] },
        errorCode: null, // '10054': email already exist
      }),
    );
  }),
  rest.put(`${odinAPI}/yousee/selfcare/emails/changepassword`, (req, res) => res()),
  rest.put(`${odinAPI}/yousee/selfcare/emails/reclaim`, (req, res) => res()),
  rest.post(`${odinAPI}/yousee/selfcare/emails/delete`, (req, res) => res()),
  rest.post(`${odinAPI}/yousee/selfcare/emails/alias/delete`, (req, res) => res()),
  rest.post(`${odinAPI}/yousee/selfcare/emails/alias/convert`, (req, res) => res()),
];
